<template>
  <div class="Menu">
    <div class="button" @click="active = true" ref="button"></div>

    <div class="backdrop" v-if="active" @click="active = false"></div>

    <div class="menu pt-4" :class="{ active }" ref="menu">
      <div
        class="item pt-2 pb-2 pl-3 pr-3"
        v-for="item in menuFilteredByUserRole"
        :key="item.url"
        @click="goTo(item.url, item.params)"
      >
        {{ item.text }}
      </div>

      <div class="item pt-2 pb-2 pl-3 pr-3" @click="signOut">Sign out</div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("auth", ["roles"]),
    menuFilteredByUserRole() {
      return this.menu.filter(
        (item) =>
          item.roles.length == 0 ||
          item.roles.some((r) => this.roles.includes(r))
      );
    },
  },
  data() {
    return {
      active: false,
      menu: [
        { text: "Home", url: "/", roles: ["reviewer", "admin"] },
        // {
        //   text: "Binary Reviews",
        //   url: "/binary-reviews",
        //   roles: ["reviewer", "admin"],
        // },
        // {
        //   text: "Severity Reviews1",
        //   url: "/severity-reviews",
        //   roles: ["reviewer", "admin"],
        // },
        // {
        //   text: "Severity Reviews2",
        //   url: "/severity-reviews2",
        //   roles: ["reviewer", "admin"],
        // },
        {
          text: "Annotation Grade Reviews",
          url: "/graded-annotation-reviews",
          roles: ["reviewer", "admin"],
        },
        {
          text: "Training Grade Reviews",
          url: "/training-grade-reviews",
          roles: ["trainee", "admin"],
        },
        {
          text: "Live Grade Reviews (Priority)",
          url: "/live-grade-reviews",
          roles: ["reviewer", "admin"],
        },
        // Common routes
        { text: "Change password", url: "/change-password", roles: [] },
      ],
    };
  },
  methods: {
    ...mapActions("auth", ["signOut"]),
    goTo(url) {
      this.$router.push(url);
      this.active = false;
    },
  },
};
</script>


<style lang="scss" scoped>
.button {
  height: 20px;
  width: 20px;
  background-image: url("../../../assets/images/menu.svg");
  background-size: contain;
  background-repeat: no-repeat;
}

.menu {
  color: #2c3e50;
  width: 60vw;
  position: fixed;
  z-index: 9999999999;
  right: 0;
  top: 0;
  transform: translateX(100%);
  height: 100vh;
  background-color: #fff;
  transition: 0.2s;
  font-size: 22px;
  cursor: pointer;
  border-bottom: 1px solid #2c3e50;
  overflow-y: auto;

  &.active {
    transform: translateX(0);
  }
}

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}
</style>

